export const EGTNL_TESTS = {
    ULX_EGTNL_AA: 51086,
    ULX_RCP_LYPS_MIGRATION: 68299
};

export const EGTNL_TESTS_MPAAS = {
    ULX_PM_VACASA: 51104,
    ULX_VALUE_PROP_BANNER: 69083,
    ULX_ADDRESSV2_VR: 56043,
    ULX_MOCK_MODAL: 64532,
    ULX_ADDRESS_FORM_CONFIGURATION_VR: 68485,
    // This feature is 100% on for en-US locale
    ULX_EN_US_PERMANENT_FEATURE_VR: 69061,
    ULX_MKTING_MIGRATION: 67157,
    ULX_PRODUCT_LISTING_MIGRATION: 71337,
    ULX_UPL_VRBO: 72575,
    ULX_SHARED_SPACE_DEFLECTION_VR: 74818
};
export const EGTNL_TESTS_KUMO = {
    ULX_VALUE_PROP_BANNER_CL: 54357,
    ULX_CL_STICKY_ABC: 61621,
    ULX_SALESFORCE_IN_LYPS: 62724,
    ULX_CL_SUBMARKETID_FETCHING: 63051,
    ULX_GTM_INTEGRATION: 65678,
    ULX_GTM_TEST: 65567,
    ULX_JOIN_RISK_CLEANUP: 67073,
    SHARED_SOURCE_AGENTIC_ONBOARDING: 68980,
    ULX_EN_US_PERMANENT_FEATURE_CL: 69458,
    // Mirrors the SHARED_DIRECT_TO_ARX DYFF flag; this app uses an EGTNL toggle because it lacks DYFF integration.
    DIRECT_TO_ARX: 74496
};
